/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import { groupBy } from "../../../../../../../helpers/utilities";
import { LinesList } from "./Lines";


export const CheckListSummary = (props) => {
    const { details, selected, classes, clsx, form } = props;
    const [productGroup, setProductGroup] = useState([]);
    useEffect(() => {
        if (details) {
            let a = [];
            let extraProducts = [];

            details && Object?.entries(details)?.map(([key, value]) => {
                return value.invoices && value.invoices?.filter((el) => { return selected.find(e => e === el.id) })?.map((data, i) => {
                    return data?.salesInvoiceItems?.map((d, i) => {
                        if (d?.productId) {
                            return a.push(d);
                        } else {
                            return extraProducts.push(d);
                        }
                    })
                })
            });

            let p = [];
            let pGroup = groupBy(a && a.length > 0 ? a : [], 'productId');
            pGroup && Object?.entries(pGroup)?.map(([key, value]) => {
                return form?.print === 'productSingle' ? form?.productInvoiceId && form?.productInvoiceId === value[0]?.id && p.push({
                    description: value[0]?.product?.productName || value[0]?.description,
                    productId: value[0]?.product?.productId || '',
                    quantity: value.reduce((a, v) => a = a + v.quantity, 0),
                    unit: value[0]?.unit || '',
                }) : p.push({
                    description: value[0]?.product?.productName || value[0]?.description,
                    productId: value[0]?.product?.productId || '',
                    quantity: value.reduce((a, v) => a = a + v.quantity, 0),
                    unit: value[0]?.unit || '',
                })
            });

            extraProducts?.length > 0 && extraProducts?.map((exProduct, i) => {
                return form?.print === 'productSingle' ? form?.productInvoiceId && form?.productInvoiceId === exProduct?.id && p.push({
                    description: exProduct?.description || '',
                    productId: '',
                    quantity: exProduct?.quantity,
                    unit: exProduct?.unit || ''
                }) : p.push({
                    description: exProduct?.description || '',
                    productId: '',
                    quantity: exProduct?.quantity,
                    unit: exProduct?.unit || ''
                })
            });

            setProductGroup(p);
        }
    }, [details]);

    return (
        <div className={clsx(classes.printFullPage)}>
            <div className={classes.downloadbars}>
                <div className={classes.downloadtopbar}></div>
                <div className={classes.downloadsecondbar} style={{ lineHeight: 1 }}>Product Delivery Checklist - Summary</div>
            </div>
            <div className={clsx(classes.downloaddetails)}>
                <div className={clsx(classes.padding20, classes.productSummary)}>
                    <div className={clsx(classes.textAlignRight, classes.bold)}>Total Quantity : {productGroup.reduce((a, v) => a = a + v.quantity, 0)}</div>
                    <LinesList data={productGroup} {...props} />
                </div>
            </div>
        </div>
    )
}